const Status = Object.freeze({

    // Status relacionados ao processo de engenharia
    ED: { sigla: "ED", descricao: "Engenharia de Detalhamento" },
    
    // Status relacionados ao processo de desenvolvimento
    LC: { sigla: "LC", descricao: "Liberado pra Coordenação" },

    // Status relacionados ao processo de fabricação
    LA: { sigla: "LA", descricao: "Liberado Almoxarifado" },
    SF: { sigla: "SF", descricao: "Solicitado para Fabricação" },

    // Status relacionados ao processo de envio e recebimento
    RE: { sigla: "RE", descricao: "Reservado" },
    RP: { sigla: "RP", descricao: "Reservado Parcial" },
    RT: { sigla: "RT", descricao: "Reservado Total" },
    ET: { sigla: "ET", descricao: "Entregue Total" },

    // Status relacionados ao processo de compras e cotação
    SC: { sigla: "SC", descricao: "Solicitado para Compras" },
    DC: { sigla: "DC", descricao: "Distribuido para Compras" },
    CT: { sigla: "CT", descricao: "Em Cotação" },
    AC: { sigla: "AC", descricao: "Aguardando Comprador" },
    AL: { sigla: "AL", descricao: "Pedido de Compra em Alteração" },

    // Status relacionados ao processo de aprovação de compras
    AP: { sigla: "AP", descricao: "Aguardando Aprovação de Comprador" },
    AA: { sigla: "AA", descricao: "Aguardando Aprovação de Coordenador de Contratos" },
    AD: { sigla: "AD", descricao: "Aguardando Aprovação de Diretoria" },
    AE: { sigla: "AE", descricao: "Aguardando Envio ao Fornecedor" },

    // Status relacionados ao processo de geração e revisão de pedidos de compra
    GP: { sigla: "GP", descricao: "Pedido de Compra Gerado" },
    RV: { sigla: "RV", descricao: "Revisão do Pedido de Compra" },

    // Status relacionados ao processo de cancelamento
    CN: { sigla: "CN", descricao: "Cancelado" },
});

const Unidade = Object.freeze({

    CX: { id: "1601ab88-673a-46b6-9762-5df519e74a0a", sigla: "CX", descricao: "Caixas" },
    CJ: { id: "f80f6c8b-1e56-4373-b8ec-3e53343ac89b", sigla: "CJ", descricao: "Conjuntos" },
    GL: { id: "a0e9fe97-931e-4b39-979f-3a7163e38c45", sigla: "GL", descricao: "Galões" },
    LB: { id: "b30a8c28-5d81-4b34-b70a-87fbd135e8fc", sigla: "LB", descricao: "Libras" },
    LT: { id: "04170ea1-e65b-4adf-a753-50acd73d1e14", sigla: "LT", descricao: "Litros" },
    MT: { id: "ccb90a44-112a-45d8-8888-54a1301085ff", sigla: "MT", descricao: "Metro" },
    M3: { id: "629329c5-e64a-4a19-a9ff-0300378e2dc0", sigla: "M3", descricao: "Metros Cúbicos" },
    M2: { id: "697046d7-23cc-4907-9412-a2e3aa6c9a39", sigla: "M2", descricao: "Metros Quadrados" },
    PL: { id: "c7c17c30-cdb1-4420-816d-8b346692c6c5", sigla: "PL", descricao: "Pallets" },
    PC: { id: "9896d7ab-42c5-4cdd-b9cb-e881f57ff48e", sigla: "PC", descricao: "Peças" },
    FT: { id: "dfead4b6-4a6e-4c7e-a556-385a2efa3107", sigla: "FT", descricao: "Pés" },
    CT: { id: "05cf5100-f526-431e-a799-039377cb63ba", sigla: "CT", descricao: "Quilates" },
    KG: { id: "2fbc4f8a-4ac1-485b-9ea4-c41b6567378e", sigla: "KG", descricao: "Quilogramas" },
    SV: { id: "8b7f5548-04b5-4dfa-858f-e04629490b09", sigla: "SV", descricao: "Serviços" },

});

export {
    Status,
    Unidade,
};
